import { createFileRoute } from '@tanstack/react-router'
import { BloodGroupReview } from '@/features/blood-group-review'
import { requireAdmin } from '@/lib/route-guards'

export const Route = createFileRoute('/_authenticated/blood-group-review/')({
  beforeLoad: requireAdmin,
  component: BloodGroupReview,
})
